import React, { createContext, useContext, useState, useEffect } from 'react';

interface User {
  id: string;
  email: string;
  isPro: boolean;
}

interface AuthContextType {
  authReady: boolean;
  user: User | null;
  isAuthed: boolean;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType>({
  authReady: false,
  user: null,
  isAuthed: false,
  logout: async () => {},
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<{ authReady: boolean; user: User | null }>({
    authReady: false,
    user: null,
  });

  useEffect(() => {
    fetch('/auth/me', { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(d => setState({ authReady: true, user: d?.user || null }))
      .catch(() => setState({ authReady: true, user: null }));
  }, []);

  const logout = async () => {
    await fetch('/auth/logout', { method: 'POST', credentials: 'include' });
    setState(s => ({ ...s, user: null }));
  };

  const contextValue: AuthContextType = {
    ...state,
    isAuthed: !!state.user,
    logout,
  };

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);